import { request } from '@umijs/max';
import { RequestType } from '@/interface';
import {
  paymentDetailType,
  paymentRecordRequestType,
  paymentRecordType,
  paymentBillParamsType,
  paymentBillRecordType,
} from '@/pages/PaymentRecord/interface';

/**
 * 查询账单列表
 * @param data
 */
export const queryPaymentRecordList = async (data: { ownerId?: string }) => {
  return request<
    Promise<RequestType<paymentRecordRequestType<Array<paymentRecordType>>>>
  >('/api/property/payment/administration/getList', {
    method: 'POST',
    data,
  });
};

/**
 * 查询账单详情
 * @param data
 */
export const queryPaymentRecordDetail = async (data: {
  paymentBillId?: string;
}) => {
  return request<Promise<RequestType<Array<paymentDetailType>>>>(
    '/api/property/PropertyOrder/getList',
    {
      method: 'POST',
      data,
    },
  );
};

/**
 * 查询账单列表
 * @param params
 */
export const queryPaymentBillRecordList = async (
  params: paymentBillParamsType,
) =>
  request<Promise<RequestType<paymentBillRecordType[]>>>(
    '/api/community/charge/bill/list',
    { method: 'GET', params },
  );
